module.exports = __webpack_public_path__ + "src/app/images/placeholderBanner.png?6f79c08a487d573aa5139770a6633264";